import type { ExamRecommendedJobType } from "@/types";

export const formatRecommendedJobsToMarkdownHandler = (jobs: ExamRecommendedJobType[]): string => jobs.map((
    {
        jobTitle,
        justification,
    },
    index,
) => `## ${index + 1}. ${jobTitle}\n\n${justification}`).join("\n\n---\n\n");
